import axios from "axios";
import { URL } from "../../Home/api";

const url = `${URL}api/catalog`;

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("token_login");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// GET all products (tanpa token jika endpoint publik)
export const getAllProducts = () => axios.get(url);

// POST: Add product
export const addProduct = (product) =>
  axios.post(url, product, getAuthHeaders());

// PUT: Update product
export const updateProduct = (id, product) =>
  axios.post(`${url}/${id}`, product, getAuthHeaders());

// DELETE: Delete product
export const deleteProduct = (id) =>
  axios.delete(`${url}/${id}`, getAuthHeaders());

// GET: Product by ID
export const getProductById = (id) =>
  axios.get(`${url}/${id}`, getAuthHeaders());
